export interface StatusBarDefinition<T = any> {
  count: number;
  cssClass: string;
  tooltipText?: string;
  attachedInfo?: T;
}

export const ProgressCoverage = {
  basic: { minValue: 0, maxValue: 29 },
  advanced: { minValue: 30, maxValue: 69 },
  superstar: { minValue: 70, maxValue: 100 },
};

export interface LinkedEntity {
  id: string;
  title: string;
  disabled?: boolean;
}

export interface LinkedEntitiesGroup {
  title: string,
  entities: LinkedEntity[]
}

export declare type LabelType = 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'transparent' | 'white';
